import { Reveal } from "@/components/pause/motion";

const tags = ["Viniyoga", "Breathwork", "Meditation", "Prenatal", "Retreats", "1-on-1"];

export const Nisha = () => {
  return (
    <section id="nisha" data-testid="nisha-section" className="bg-[#F2EDE5] py-24 md:py-32">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 flex flex-col min-[900px]:flex-row items-center gap-14 min-[900px]:gap-20">
        {/* Portrait with offset yellow frame */}
        <div className="w-full min-[900px]:w-[42%]">
          <Reveal>
            <div className="relative w-full max-w-sm mx-auto">
              <div className="absolute inset-0 translate-x-4 translate-y-4 border-2 border-[#F5C800] rounded-sm" />
              <div className="relative overflow-hidden rounded-sm aspect-[4/5]">
                <img src="/images/photo2.jpg" alt="Nisha, founder of Pause." className="w-full h-full object-cover" />
              </div>
            </div>
          </Reveal>
        </div>

        {/* Bio */}
        <div className="w-full min-[900px]:w-[58%]">
          <Reveal>
            <p className="font-body text-xs uppercase tracking-[0.28em] text-[#8C8070] mb-6">Meet Your Teacher</p>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-display font-light text-5xl md:text-6xl leading-[0.98] tracking-tight text-[#1A1A1A] mb-8">
              Hi, I&apos;m <span className="italic text-[#3B5A3A]">Nisha.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="space-y-5 font-body text-base md:text-lg leading-relaxed text-[#1A1A1A]/75 max-w-2xl">
              <p>
                For over a decade I&apos;ve taught yoga the slow way — meeting each body where it is.
                Trained in the tradition of T. Krishnamacharya through YogaVahini, Chennai, my roots
                are in Viniyoga: the practice of adapting yoga to the person, so it stays kind to you for life.
              </p>
              <p>
                Between city classes and forest retreats, my work is simple: help you breathe deeper, move
                freer, and find a little more quiet in a noisy world.
              </p>
            </div>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="mt-9 flex flex-wrap gap-3">
              {tags.map((t) => (
                <span
                  key={t}
                  data-testid={`nisha-tag-${t.toLowerCase().replace(/[^a-z0-9]/g, "-")}`}
                  className="font-body text-[13px] px-4 py-2 rounded-full border border-[#8C8070]/40 text-[#1A1A1A]/80 hover:border-[#3B5A3A] hover:text-[#3B5A3A] transition-colors duration-300"
                >
                  {t}
                </span>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
